<template>
    <div v-if="!!planningItem">
        <md-card :key="index" v-for="(report, index) in planningItem.visit_reports">
            <md-card-media-actions>
                <md-card-content>
                    <div class="md-subhead">
                        <hour-display :date-time="report.creation_date" :date-time-format="'DD/MM/YYYY HH:mm:ss'" />
                        <div>- {{ report.state }}</div>
                    </div>
                    <div style="white-space: pre">{{ report.data.comment }}</div>
                    <div v-if="report.data.payment_method">
                        Betaalmethode:
                        {{ parsePaymentMethodTypeReadable(report.data.payment_method) }}
                    </div>
                </md-card-content>
                <md-card-actions>
                    <md-button @click="editVisitReport(report)" class="md-icon-button">
                        <md-icon>edit</md-icon>
                    </md-button>
                </md-card-actions>
            </md-card-media-actions>
        </md-card>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import HourDisplay from '../../../components/utils/HourDisplay.vue';
import { IPlanningItemEntity, IPlanningItemReportEntity } from '@phrospr/api-backend';
import { parsePaymentMethodTypeReadable } from '@phrospr/lib-core/src/engine/planning-item.engine';

@Component({
    components: { HourDisplay },
})
export default class PlanningDetailVisitReportsView extends Vue {
    parsePaymentMethodTypeReadable = parsePaymentMethodTypeReadable;

    get planningItem(): IPlanningItemEntity {
        return this.$store.state.planningItem;
    }

    public editVisitReport(visitReport: IPlanningItemReportEntity) {
        this.$store.commit('editPlanningItemReport', JSON.parse(JSON.stringify(visitReport)));
        return this.$router.push('/planning-item-report/edit');
    }
}
</script>

<style scoped></style>
